'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SuccessNotification = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Notification = require('../Notification/Notification');

var _Notification2 = _interopRequireDefault(_Notification);

var _SuccessNotificationStyle = require('./SuccessNotification.style.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A notification that implements the success styles of your theme.
 * Takes the exact same properties as Notification.
 */
var SuccessNotification = exports.SuccessNotification = function SuccessNotification(props) {
  return _react2.default.createElement(_Notification2.default, props);
};

SuccessNotification.propTypes = {
  /**
   * bool that determines whether the success notification renders with a closeIcon
   */
  omitCloseIcon: _propTypes2.default.bool
};

exports.default = (0, _glamorous2.default)(SuccessNotification)(_SuccessNotificationStyle.defaultStyle, _SuccessNotificationStyle.mapPropsAndThemeToStyle);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/notifications/SuccessNotification/SuccessNotification.js
// module id = 429
// module chunks = 0